import { atom } from "recoil";

export const promotionEditModalStore = atom({
	key: "promotionEditModalStore",
	default: {
		show: false,
		loaded: false,
		currentOption: {
			type: [{value: "fiat", label: "fiat"}, {value: "crypto", label: "crypto",}],
		},
		id: 0,
		type: "absolute",
		typePromo: "",
		fromAmount: false,
		toAmount: false,
		startDate: "",
		endDate: "",
		percent: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
